import { render } from "./TableHistory.vue?vue&type=template&id=e60e0ba8"
import script from "./TableHistory.vue?vue&type=script&lang=js"
export * from "./TableHistory.vue?vue&type=script&lang=js"
script.render = render

export default script